import React from 'react';
const IconPersonOne = () => {
    return (React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { d: "M12 12C14.76 12 17 9.76 17 7C17 4.24 14.76 2 12 2C9.24 2 7 4.24 7 7C7 9.76 9.24 12 12 12ZM12 4C13.65 4 15 5.35 15 7C15 8.65 13.65 10 12 10C10.35 10 9 8.65 9 7C9 5.35 10.35 4 12 4Z", fill: "#2D2E2E" }),
        React.createElement("path", { d: "M18.7001 14H5.30014L2.39014 22H17.3501L16.6201 20H5.24014L6.70014 16H17.3001L19.4801 22H21.6101L18.7001 14Z", fill: "#2D2E2E" })));
};
export default IconPersonOne;
//# sourceMappingURL=personOne.js.map
// @zapier/design-system@6.1.0 (fd86aa2ab)
